export default {
  namespaced: true,
  state: () => ({
    factories: [],
    loading: false,
    error: null,
  }),
  getters: {
    allFactories: state => state.factories,
    totalFactories: state => state.factories.length,
  },
  mutations: {
    setFactories(state, data) { state.factories = data; },
    addFactory(state, f) { state.factories.push(f); },
    updateFactory(state, f) {
      const i = state.factories.findIndex(x => x.id === f.id);
      if(i !== -1) state.factories.splice(i, 1, f);
    },
    removeFactory(state, id) { state.factories = state.factories.filter(f => f.id !== id); },
    setLoading(state, loading) { state.loading = loading; },
    setError(state, error) { state.error = error; },
  },
  actions: {
    async fetchFactories({ commit }) {
      commit('setLoading', true);
      try {
        const data = await new Promise(resolve =>
          setTimeout(() => resolve([{ id:1,name:'EVERGREEN',location:'Sotik'},{id:2,name:'CHOIMIM',location:'Kapsabet'}]), 500)
        );
        commit('setFactories', data);
      } catch(err){ commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async addFactory({ commit }, f) { commit('addFactory', { ...f, id: Date.now() }); },
    async updateFactoryAction({ commit }, f) { commit('updateFactory', f); },
    async deleteFactory({ commit }, id) { commit('removeFactory', id); },
  },
};
